import { Helmet } from "react-helmet";
import CaseStudyHero from "../../components/case-studies/cases/reusables/CaseStudyHero";
import desktop from "../../assets/images/case-studies/cases/hanasafaris/hanasafaris-desktop.jpg";
import HanaSafarisCaseStudyBody from "../../components/case-studies/cases/HanaSafarisCaseStudyBody";

export default function HanaSafaris() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/case-studies/hanasafaris"
        />
        <meta
          name="description"
          content="Explore how NTUNA.COM translated a distinctive safari concept into a professional brand and a world-class digital experience through brand identity design, a high-performance website, SEO, professional logo design and social media re-setup."
        />
        <meta
          property="og:description"
          content="Explore how NTUNA.COM translated a distinctive safari concept into a professional brand and a world-class digital experience through brand identity design, a high-performance website, SEO, professional logo design and social media re-setup."
        />
        <meta
          property="og:title"
          content="Hana Safaris Case Study | Brand Identity, High-performance Website & Logo Design | NTUNA.COM"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779608354/ntuna-head-office_banner-1200x628_qeg2go.jpg"
        />

        <meta
          name="twitter:title"
          content="Hana Safaris Case Study | Brand Identity, High-performance Website & Logo Design | NTUNA.COM"
        />
        <meta
          name="twitter:text:title"
          content="Hana Safaris Case Study | Brand Identity, High-performance Website & Logo Design | NTUNA.COM"
        />
        <meta
          name="twitter:description"
          content="Explore how NTUNA.COM translated a distinctive safari concept into a professional brand and a world-class digital experience through brand identity design, a high-performance website, SEO, professional logo design and social media re-setup."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779608354/ntuna-head-office_banner-1200x628_qeg2go.jpg"
        />
        <title>
          Hana Safaris Case Study | Brand Identity, High-performance Website &
          Logo Design | NTUNA.COM
        </title>
      </Helmet>
      <CaseStudyHero
        client="Hana Safaris"
        title="Hana Safaris"
        subtitle="Explore how NTUNA.COM translated a distinctive safari concept into a professional brand and a world-class digital experience through brand identity design, a high-performance website, SEO, professional logo design and social media re-setup — turning the company into the world's first safari company to exclusively focus on Uganda’s Five Giants™"
        caseImg={desktop}
      />
      <HanaSafarisCaseStudyBody />
    </>
  );
}
